import { CallToActionKind, UntypedObject } from '@/types';
import Tile from '@/components/common/Tile';
import Icon from '@/components/common/iconedLinks/Icon';
import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';
import { useTranslation } from 'next-i18next';

import styles from './SelectedFilters.module.scss';
import { URLS } from '@/constants/urls';

export const SelectedFilters = ({ selectedFiltersInfos, handleDelete, handleDeleteAll }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      {selectedFiltersInfos.map((tag: UntypedObject) => (
        <Tile
          key={tag.filterString} content={{ paragraph: tag.label }} littleGap
          trailingContent={
            <Icon src={URLS.CROSS_BLACK} alt="close" width={24} height={24} />
          }
          inlineText
          onClick={() => handleDelete(tag)}
        />
      ))}
      {selectedFiltersInfos.length > 1 && (
        <CallToActionContainer
          kind={CallToActionKind.TERTIARY}
          onClick={handleDeleteAll}
          className={styles['delete-all']}
        >
          {t('category:filter.deleteAll')}
        </CallToActionContainer>
      )}
    </div>
  );
};

export default SelectedFilters;
